// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useCallback } from 'react';
import '../../../styles/components/PartiesList.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import BookingOptionListMobile from './BookingOptionListMobile';
import { truncateHoursString } from '../utils';
import DragnDropTable from '../../utils/DragnDrop/DragnDropTable';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import ActivitySectionButtons from '../ActivitySectionButtons';
import BookingOptionListElement from './BookingOptionListElement';

export const BookingOptionList = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  content,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onBookingOptionEdit,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onReorderBookingOptions,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  updateActivity,
}) => {
  const [initalBookingOptionOrder, setInitialBookingOptionOrder] = useState([
    ...content,
  ]);
  const [edited, setEdited] = useState(false);

  const element = useCallback(
    ({ value }) => (
      <BookingOptionListElement
        value={value}
        onBookingOptionEdit={onBookingOptionEdit}
      />
    ),
    [onBookingOptionEdit]
  );

  if (isMobileResolution()) {
    return (
      <BookingOptionListMobile
        content={content}
        onBookingOptionEdit={onBookingOptionEdit}
        handleHours={truncateHoursString}
      />
    );
  }

  const onSaveClick = async event => {
    event.preventDefault();
    await updateActivity({ bookingOptions: content });
    setInitialBookingOptionOrder(content);
    setEdited(false);
  };

  const onResetClick = () => {
    onReorderBookingOptions({
      newBookingOptionOrder: initalBookingOptionOrder,
    });
    setEdited(false);
  };

  const onChange = options => {
    setEdited(true);
    onReorderBookingOptions(options);
  };

  return (
    <div>
      <ActivitySectionButtons
        onSaveClick={onSaveClick}
        onResetClick={onResetClick}
        disabled={!edited}
      />
    <div className='partieslist'>

      <DragnDropTable
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        content={content}
        onChange={onChange}
        headers={[
          'Title',
          'Description',
          'Duration',
          'Hours',
          'Interval',
          'Price',
          'Pricing Modal',
          'SubType',
        ]}
        Element={element}
        receiver='newBookingOptionOrder'
      />
    </div>
    </div>
  );
};
